import React, { useState, useEffect, useRef } from "react";
import { RiCloseLine } from "react-icons/ri";
import countries from "./countries.json";
const EditPos = ({ open, setOpen, formData, setFormData, mutation, pos }) => {
  const [searchQuery, setSearchQuery] = useState(pos?.pays || "");
  const [stateSearch, setStateSearch] = useState(pos?.address || "");
  const [selectedPays, setSelectedPays] = useState(null);
  console.log("sss", formData)
  // Initialize selectedPays when pos changes
  useEffect(() => {
    if (pos) {
      const matchedCountry = countries.find((c) => c.name_fr === pos.pays);
      setSelectedPays(matchedCountry);

      setSearchQuery(pos.pays || "");
      setStateSearch(pos.address || "");

      setFormData({
        name: pos.name || "",
        address: pos.address || "",
        ville: pos.ville || "",
        pays: pos.pays || "",
        code_postal: pos.code_postal || "",
        contact_number: pos.contact_number || "",
        responsable_name: pos.responsable_name || "",
        mail: pos.mail || "",
        type: pos.type
      });
    }
  }, [pos, setFormData]);

  const countryRef = useRef(null);
  const stateRef = useRef(null);

  const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
  const [isStateDropdownOpen, setIsStateDropdownOpen] = useState(false);

  const filteredCountries = countries.filter((country) =>
    country.name_fr.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Get states based on selected country
  // const countryStates = selectedPays
  //   ? cities.filter((c) => c.stateId === String(selectedPays.id))
  //   : [];
  // const filteredStates = countryStates.filter((state) =>
  //   state.name_fr.toLowerCase().includes(stateSearch.toLowerCase())
  // );

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    setFormData({ ...formData, pays: value });

    setIsCountryDropdownOpen(value !== "");
  };
  function convertUnicodeToEmoji(unicode) {
    return unicode
      .split(" ")
      .map((u) => String.fromCodePoint(parseInt(u.replace("U+", ""), 16)))
      .join("");
  }
  const handleStateSearchChange = (e) => {
    const value = e.target.value;
    setStateSearch(value);

    setIsStateDropdownOpen(value !== "");
  };

  const handleCountrySelect = (country) => {
    setFormData({ ...formData, pays: country.name_fr });
    setSearchQuery(country.name_fr);
    setSelectedPays(country);
    setIsCountryDropdownOpen(false);
    setStateSearch("");
    setIsStateDropdownOpen(false);
  };

  const handleStateSelect = (state) => {
    setFormData({ ...formData, address: state.name_fr });
    setStateSearch(state.name_fr);
    setIsStateDropdownOpen(false);
  };

  if (!open) return null;

  const token = localStorage.getItem("token");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
      // Also update address when city changes
      ...(name === 'city' ? { address: value } : {})
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const dataToSend = {
      ...formData,
      type: formData.type, // Default to "Web" if not set
    };
    mutation.mutate({ id: pos.id, data: dataToSend, token });
  };

  return (
    <div
      className="fixed inset-0 z-50"
      style={{ zIndex: 9999, overflow: "visible" }}
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75"
        aria-hidden="true"
        onClick={() => setOpen(false)} // Close modal when clicking the overlay
      />

      {/* Modal Content */}
      <div className="flex items-center justify-center min-h-screen p-4">
        <div
          className="relative w-full max-w-lg mx-auto bg-white shadow-lg rounded-lg overflow-hidden"
          onClick={(e) => e.stopPropagation()} // Prevent clicks inside the modal from closing it
        >
          {/* Header */}
          <div className="flex justify-between items-center p-6 bg-[#b269ae] border-b border-gray-500/30 pb-4">
            <h3
              id="modal-title"
              className="text-lg font-medium leading-6 text-white"
            >
              Modifier le point de vente
            </h3>
            <button
              type="button"
              className="inline-flex items-center justify-center p-1.5 text-gray-400 hover:text-gray-500 hover:scale-105 duration-200"
              onClick={() => setOpen(false)}
            >
              <RiCloseLine className="h-6 w-6 text-white" aria-hidden="true" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4 p-6">
            <div className="grid grid-cols-1 gap-x-4 sm:grid-cols-2 gap-y-4 mt-8">
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Nom du magasin
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={formData.name || ""}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-[--secondaryColor] focus:ring-[--secondaryColor] sm:text-sm h-12"
                />
              </div>
              <div>
                <label
                  htmlFor="pays"
                  className="block text-sm font-medium text-gray-700"
                >
                  Pays
                </label>
                <div className="relative" ref={countryRef}>
                  <input
                    id="pays"
                    name="pays"
                    type="text"
                    value={searchQuery}
                    onClick={() =>
                      setIsCountryDropdownOpen(!isCountryDropdownOpen)
                    }
                    onChange={handleSearchChange}
                    placeholder="Rechercher un pays..."
                    className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 h-12"
                    autoComplete="off"
                  />
                  {isCountryDropdownOpen && (
                    <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto">
                      {filteredCountries.length > 0 ? (
                        filteredCountries.map((country) => (
                          <li
                            key={country.id}
                            onClick={() => handleCountrySelect(country)}
                            className="px-3 py-2 cursor-pointer hover:bg-gray-200"
                          >
                            {convertUnicodeToEmoji(country.emojiU)}{" "}
                            {country.name_fr}
                          </li>
                        ))
                      ) : (
                        <li className="px-3 py-2 text-gray-500">
                          Aucun pays trouvé
                        </li>
                      )}
                    </ul>
                  )}
                </div>
              </div>

              <div>
                <label
                  htmlFor="ville"
                  className="block text-sm font-medium text-gray-700"
                >
                  Ville
                </label>
                <input
                  id="ville"
                  name="ville"
                  type="text"
                  value={formData.ville}
                  onChange={handleChange}
                  placeholder="Ville"
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 h-12"
                />
              </div>
              <div>
                <label
                  htmlFor="address"
                  className="block text-sm font-medium text-gray-700"
                >
                  Adresse
                </label>
                <input
                  id="address"
                  name="address"
                  type="text"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Adresse"
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 h-12"
                />
              </div>
              <div>
                <label
                  htmlFor="code_postal"
                  className="block text-sm font-medium text-gray-700"
                >
                  Code Postal
                </label>
                <input
                  id="code_postal"
                  name="code_postal"
                  type="text"
                  value={formData.code_postal || ""}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-[--secondaryColor] focus:ring-[--secondaryColor] sm:text-sm h-12"
                />
              </div>
              <div>
                <label
                  htmlFor="contact_number"
                  className="block text-sm font-medium text-gray-700"
                >
                  Numéro de contact
                </label>
                <input
                  id="contact_number"
                  name="contact_number"
                  type="text"
                  value={formData.contact_number || ""}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-[--secondaryColor] focus:ring-[--secondaryColor] sm:text-sm h-12"
                />
              </div>
              <div>
                <label
                  htmlFor="responsable_name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Responsable name
                </label>
                <input
                  id="responsable_name"
                  name="responsable_name"
                  type="text"
                  value={formData.responsable_name || ""}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-[--secondaryColor] focus:ring-[--secondaryColor] sm:text-sm h-12"
                />
              </div>
              <div>
                <label
                  htmlFor="mail"
                  className="block text-sm font-medium text-gray-700"
                >
                  Mail
                </label>
                <input
                  id="mail"
                  name="mail"
                  type="text"
                  value={formData.mail || ""}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-[--secondaryColor] focus:ring-[--secondaryColor] sm:text-sm h-12"
                />
              </div>
              <div>
                <label
                  htmlFor="type"
                  className="block text-sm font-medium text-gray-700"
                >
                  Type
                </label>
                <select
                  id="type"
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-[--secondaryColor] focus:ring-[--secondaryColor] sm:text-sm h-12"
                >
                  <option value="0">Web</option>
                  <option value="1">Non-Web</option>
                </select>
              </div>
            </div>
            <div className="mt-6 flex justify-end gap-6">
              <button
                type="button"
                className="block rounded-md bg-purple-400 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-yellow-300 duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"
                onClick={() => setOpen(false)}
              >
                Annuler
              </button>
              <button
                type="submit"
                className="block rounded-md bg-[#b269ae] px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-yellow-300 duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"
              >
                Modifier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditPos;
